module.exports = __webpack_public_path__ + "img/logo.8c2e0d6a.png";